<div class="bg position-relative">
  <div class="confetti"></div>
  <div class="min-height-xs-100vh space-top-2">
    <div class="start__header">
      <div class="header__title">
        <h1>
          <div class="counter">
            <span class="counter-num">4</span>
            <span class="counter-num">1</span>
            <span class="counter-num">4</span>
            adventurers have <br class="linebreak">climbed with Kopa Tours.
          </div>
        </h1>
      </div>
      <div class="header__stories">
        <div class="header__photo header__photo--1"></div>
        <div class="header__photo header__photo--2"></div>
        <div class="header__photo header__photo--3"></div>
        <div class="header__photo header__photo--4"></div>
        <div class="scrollable">
          <a class="header__story header__story--1" href="https://www.bookmundi.com/companies/kopa-tours/c2163" target="_blank" rel="nofollow">
            <h2 class="header__story-title">
              Never in my life have I felt so exhausted, yet fulfilled..
            </h2>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="header__story-arrow"><path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z">
            <!----></path>
            </svg>
          </a>
          <a class="header__story header__story--2" href="https://www.hometownlife.com/story/life/2020/02/26/kindergarten-teacher-says-climbing-kilimanjaro-changed-her-life/4823179002/" target="_blank" rel="nofollow">
            <h2 class="header__story-title">
              Kindergarten teacher gets new lease on life
            </h2>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="header__story-arrow"><path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z">
            <!----></path>
            </svg>
          </a>
          <a class="header__story header__story--3" href="https://www.tripadvisor.com/Attraction_Review-g317084-d19493872-Reviews-Kopa_Tours-Moshi_Kilimanjaro_Region.html" target="_blank" rel="nofollow">
            <h2 class="header__story-title">
              "we really enjoyed the private butler service ..."
            </h2>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="ember56" class="ember-view header__story-arrow"><path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z">
            <!----></path>
            </svg>
          </a>
        </div>
      </div>
    </div>

    <div class="container pt-5 content__awards">
      <!-- Title -->
      <div class="w-md-80 w-lg-50 mb-5">
        <h3>Kopa Tours - Awards & Press</h3>
      </div>
      <!-- End Title -->
      <app-awards-and-press></app-awards-and-press>
    </div>

    <div class="container">
      <div class="row py-5">
        <div class="col-12">
          <app-climb-reviews></app-climb-reviews>
          <div class="bg-img-hero bg-img-footer mx-0">
            <div class="container py-6">
              <p class="brand-header">Interested in your own Kilimanjaro Climb with Kopa Tours?</p>
              <p class="footer-body">Learn Which Route is <b class="bold-footer">Best for You</b>. 19,341 feet high - the tallest freestanding mountain in the world. There are many routes to get you to the summit. Discover which one best suits your needs by taking our <b>personalized route quiz.</b></p>
              <app-kopa-button link="/kilimanjaro/route-quiz" fragment="gritCard" classes="my-auto transition-3d-hover" color="primary" text="Take the Quiz"></app-kopa-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
